module.exports = __webpack_public_path__ + "img/7.ed4d0723.png";